import * as types from './action_types';
import NotificationPreferencesService from '../../services/notification_preferences_service';

export const fetch = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.NOTIFICATION_PREFERENCES_RETRIEVING });
      const notificationPreferencesData = await NotificationPreferencesService.fetch();
      const notificationPreferences = {
        deliveryMethod: notificationPreferencesData.delivery_method,
        stopEverything: notificationPreferencesData.stop_everything,
        tackArchive: notificationPreferencesData.tack_archive,
        newFollowers: notificationPreferencesData.new_followers,
        wordsFromPeopleFollowed: notificationPreferencesData.words_from_people_followed,
        points: notificationPreferencesData.points,
        commentsFromPeopleFollowed: notificationPreferencesData.comments_from_people_followed,
        lastWeeksMostTacked: notificationPreferencesData.last_weeks_most_tacked,
        likes: notificationPreferencesData.likes,
        commentMentions: notificationPreferencesData.comment_mentions
      }
      dispatch({ type: types.NOTIFICATION_PREFERENCES_RETRIEVED, notificationPreferences });
    } catch(error) {
      dispatch({ type: types.NOTIFICATION_PREFERENCES_ERROR, error });
    }
  }
}

export const update = (preferences) => {
  return async(dispatch) => {
    try {
      await NotificationPreferencesService.update(preferences);
      dispatch({ type: types.NOTIFICATION_PREFERENCES_UPDATED });
    } catch(error) {
      dispatch({ type: types.NOTIFICATION_PREFERENCES_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/notification_preferences/actions.js